import config from 'lib/config'

function logSupportPage(message: string, payload: Record<string, unknown>) {
  if (!config.debug) return
  console.info('[SupportPage]', message, payload)
}

/** JWT payload `id` is a number after JSON.parse; allowlist env is always string — compare as strings. */
export function canAccessSupportPage(
  released: boolean,
  userId: string | number | undefined
): boolean {
  if (released) {
    logSupportPage('canAccessSupportPage', { released: true, granted: true, reason: 'SUPPORT_PAGE_RELEASED' })
    return true
  }
  if (userId == null || userId === '') {
    logSupportPage('canAccessSupportPage', {
      released: false,
      rawUserId: userId,
      granted: false,
      reason: 'NO_USER_ID',
    })
    return false
  }
  const uid = String(userId)
  const rawAllowlist = config.supportPageTesters ?? ''
  const allowed = rawAllowlist.split(',').map((s) => s.trim()).filter(Boolean)
  const granted = allowed.includes(uid)
  logSupportPage('canAccessSupportPage', {
    released: false,
    rawUserId: userId,
    uid,
    allowlistRawLength: rawAllowlist.length,
    allowedIds: allowed,
    granted,
    reason: granted ? 'ALLOWLIST_MATCH' : 'ALLOWLIST_MISS',
  })
  return granted
}
